import(/* webpackMode: "eager" */ "/vercel/path0/app/blog/[slug]/page.tsx");
